import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const KoinotitaReturnChip = () => {
  const location = useLocation();
  const [mode, setMode] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    if (from === "koinotita" || from === "koinotita-guest" || from === "gymnastirio" || from === "praktiki") {
      try { sessionStorage.setItem("from_koinotita", from); } catch (e) {}
      setMode(from);
    } else {
      try { setMode(sessionStorage.getItem("from_koinotita")); } catch (e) { setMode(null); }
    }
  }, [location]);

  if (!mode || location.pathname === "/koinotita" || location.pathname === "/gymnastirio" || location.pathname === "/praktiki") return null;

  const isGym = mode === "gymnastirio";
  const isPraktiki = mode === "praktiki";
  const target = isPraktiki ? "/praktiki" : isGym ? "/gymnastirio" : mode === "koinotita-guest" ? "/koinotita?guest=1" : "/koinotita";

  return (
    <a
      href={target}
      target="_top"
      data-testid="koinotita-return-chip"
      style={{
        position: "fixed",
        ...(location.pathname === "/pacer" ? { top: "12px" } : { bottom: "16px" }),
        left: "16px",
        zIndex: 9999,
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 14px",
        borderRadius: "9999px",
        background: "rgba(12, 20, 38, 0.92)",
        border: "1px solid rgba(212, 175, 55, 0.6)",
        color: "#e8d48b",
        fontSize: "13px",
        fontWeight: 600,
        textDecoration: "none",
        boxShadow: "0 4px 14px rgba(0,0,0,0.45)",
        backdropFilter: "blur(6px)",
      }}
    >
      {isPraktiki ? "🌅 Πρακτική" : isGym ? "🏋️ Γυμναστήριο" : "🧰 Τα εργαλεία μου"}
    </a>
  );
};
